const SIZES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]',
};

export default function Spinner({ size = 'md', className = '', label = 'Loading' }) {
  return (
    <span
      role="status"
      aria-label={label}
      className={`inline-block shrink-0 animate-spin-slow rounded-full border-current border-r-transparent align-[-0.125em] ${SIZES[size] ?? SIZES.md} ${className}`}
    />
  );
}

/** Full-area loading state, used as the Suspense fallback for routes. */
export function PageSpinner({ label = 'Loading' }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-brand">
      <Spinner size="lg" label={label} />
      <p className="text-sm text-ink-muted">{label}…</p>
    </div>
  );
}
